import { render, staticRenderFns } from "./actMaleRules.vue?vue&type=template&id=ce88cbaa&scoped=true"
import script from "./actMaleRules.vue?vue&type=script&lang=js"
export * from "./actMaleRules.vue?vue&type=script&lang=js"
import style0 from "./actMaleRules.vue?vue&type=style&index=0&id=ce88cbaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce88cbaa",
  null
  
)

export default component.exports